export default class Hit {
	constructor(si, pattern, pi) {
		this.si = si;
		this.p = pattern;
		this.pi = pi;
	}
}
